export * from './partners-list-widget'
